/*
 *   Copyright (c) 2026 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import { createAgent } from '@vlinder-web/plugin-agent-service-react';
import {
  TelemetryEventService,
  ITelemetryEventMethods,
} from './components';

export type TelemetryAgent = ITelemetryEventMethods;

const getPlugins = () => {
  return [new TelemetryEventService()];
};

export const getAgent = () => {
  return createAgent<TelemetryAgent>({
    plugins: getPlugins(),
  });
};
